import axiosInstance from '@helm/services/api/wrapper/axiosInstance'
import { request as __request } from '@helm/services/api/client/core/request'
import type { CancelablePromise } from '@helm/services/api/client'
import { BaseHttpRequest } from '@helm/services/api/client'
import type { ApiRequestOptions } from '@helm/services/api/client/core/ApiRequestOptions'
import type { OpenAPIConfig } from '@helm/services/api/client'

export class AxiosHttpWrapper extends BaseHttpRequest {
    constructor(config: OpenAPIConfig) {
        super(config)
    }

    public override request<T>(options: ApiRequestOptions): CancelablePromise<T> {
        return __request(this.config, options, axiosInstance)
    }
}
